// Columns for salaryAndBenefits

let moment = require('moment');



export let colSalaryAndBenefitsStartDate = {
    colId: 'salaryAndBenefitsStartDate',
    headerName: 'Start Date',
    field: 'salaryAndBenefitsStartDate',
    width: 50,
    sortable: true
};

export let colSalaryAndBenefitsEndDate = {
    colId: 'salaryAndBenefitsEndDate',
    headerName: 'End Date',
    field: 'salaryAndBenefitsEndDate',
    width: 50,
    sortable: true
};

export let colCmeAnnualAllowance = {
    colId: 'cmeAnnualAllowance',
    headerName: 'CME Annual Allowance',
    field: 'cmeAnnualAllowance',
    width: 50,
    sortable: true
};

export let colDbsAnnualAllowance = {
    colId: 'dbsAnnualAllowance',
    headerName: 'DBS Annual Allowance',
    field: 'dbsAnnualAllowance',
    width: 50,
    sortable: true
};

export let colStudentLoanAnnualReimbursement = {
    colId: 'studentLoanAnnualReimbursement',
    headerName: 'Student Loan Annual Reimbursement',
    field: 'studentLoanAnnualReimbursement',
    width: 50,
    sortable: true
};

export let colAdminStipenedAnnualMax = {
                                            colId: 'adminStipenedAnnualMax',
                                            headerName: 'Administrative Stipend Annual Max',
                                            field: 'adminStipenedAnnualMax',
                                            width: 50,
                                            sortable: true
                                        };

export let colAdminStipenedDescription = {
                                            colId: 'adminStipenedDescription',
                                            headerName: 'Administrative Stipened Description',
                                            field: 'adminStipenedDescription',
                                            width: 100,
                                            sortable: true
                                        };

export let colAdminStipenedHourlyRate = {
                                            colId: 'adminStipenedHourlyRate',
                                            headerName: 'Administrative Stipend Hourly Rate',
                                            field: 'adminStipenedHourlyRate',
                                            width: 50,
                                            sortable: true
                                        };

export let colCollaboratives = {
                                    colId: 'collaboratives',
                                    headerName: 'Collaborative(s)',
                                    field: 'collaboratives',
                                    width: 50,
                                    sortable: true
                                };


export let colCommencementBonus =   {
                                        colId: 'commencementBonus',
                                        headerName: 'Commencement Bonus',
                                        field: 'commencementBonus',
                                        width: 50,
                                        sortable: true
                                    };


export let colCompensation =    {
                                    colId: 'compensation',
                                    headerName: 'Compensation',
                                    field: 'compensation',
                                    width: 50,
                                    sortable: true
                                };

export let colfteStatusDate =   {
                                    colId: 'fteStatusDate',
                                    headerName: 'FTE STATUS/AS OF DATE',
                                    field: 'fteStatusDate',
                                    width: 50,
                                    sortable: true
                                };

export let colHousingStipend =  { 
                                    colId: 'housingStipend',
                                    headerName: 'Housing Stipend',
                                    field: 'housingStipend',
                                    width: 50,
                                    sortable: true
                                };

export let colIncentiveComp =   { 
                                    colId: 'incentiveComp',
                                    headerName: 'Incentive Comp',
                                    field: 'incentiveComp',
                                    width: 50,
                                    sortable: true
                                };

export let colMiscComp =    {
                                colId: 'miscComp',
                                headerName: 'Miscellaneous Compensation',
                                field: 'miscComp',
                                width: 50,
                                sortable: true
                            };

export let colMiscCompAmount =  {
                                    colId: 'miscCompAmount',
                                    headerName: 'Miscellaneous Compensation Amount',
                                    field: 'miscCompAmount',
                                    width: 50,
                                    sortable: true
                                };


export let colNppSupervisoryAgreement = {
                                            colId: 'nppSupervisoryAgreement',
                                            headerName: 'NPP Supervisory Agreement Co-Signing Physician Name',
                                            field: 'nppSupervisoryAgreement',
                                            width: 50,
                                            sortable: true,
                                        };

export let colNppSupervisoryAgreementDate = {
                                                colId: 'nppSupervisoryAgreementDate',
                                                headerName: 'NPP Supervisory Agreement Date Signed',
                                                field: 'nppSupervisoryAgreementDate',
                                                width: 50,
                                                sortable: true,
                                                cellRenderer: dateFormatter
                                            };


export let colNppAgreementOnFile =  {
                                        colId: 'nppAgreementOnFile',
                                        headerName: 'NPP Supervisory Agreement on File (Y/N)',
                                        field: 'nppAgreementOnFile',
                                        width: 50,
                                        sortable: true
                                    };


export let colRelocationAllowance = {
                                        colId: 'relocationAllowance',
                                        headerName: 'Relocation Allowance',
                                        field: 'relocationAllowance',
                                        width: 50,
                                        sortable: true
                                    };

export let colRetentionBonus =  {
                                    colId: 'retentionBonus',
                                    headerName: 'Retention Bonus',
                                    field: 'retentionBonus',
                                    width: 50,
                                    sortable: true
                                };

export let colRetentionBonusNotes =  {
                                        colId: 'retentionBonusNotes',
                                        headerName: 'Retention Bonus Notes',
                                        field: 'retentionBonusNotes',
                                        width: 50,
                                        sortable: true
                                    };


export let colRvuIncentiveInfo =  {
                                        colId: 'rvuIncentiveInfo',
                                        headerName: 'RVU Incentive Information',
                                        field: 'rvuIncentiveInfo',
                                        width: 50,
                                        sortable: true
                                    };



export let allColumns = [
    colAdminStipenedAnnualMax,
    colAdminStipenedDescription,
    colAdminStipenedHourlyRate,
    colCollaboratives,
    colCommencementBonus,
    colCompensation,
    colfteStatusDate,
    colHousingStipend,
    colIncentiveComp,
    colMiscComp,
    colMiscCompAmount,
    colNppSupervisoryAgreement,
    colNppSupervisoryAgreementDate,
    colNppAgreementOnFile,
    colRelocationAllowance,
    colRetentionBonus,
    colRetentionBonusNotes,
    colRvuIncentiveInfo
];



export let columnSelectList = [
    {
        value: colAdminStipenedAnnualMax,
        viewValue: colAdminStipenedAnnualMax.headerName
    },
    {
        value: colAdminStipenedDescription,
        viewValue: colAdminStipenedDescription.headerName
    },
    {
        value: colAdminStipenedHourlyRate,
        viewValue: colAdminStipenedHourlyRate.headerName
    },
    {
        value: colCollaboratives,
        viewValue: colCollaboratives.headerName
    },
    {
        value: colCommencementBonus,
        viewValue: colCommencementBonus.headerName
    },
    {
        value: colCompensation,
        viewValue: colCompensation.headerName
    },
    {
        value: colfteStatusDate,
        viewValue: colfteStatusDate.headerName
    },
    {
        value: colHousingStipend,
        viewValue: colHousingStipend.headerName
    },
    {
        value: colIncentiveComp,
        viewValue: colIncentiveComp.headerName
    },
    {
        value: colMiscComp,
        viewValue: colMiscComp.headerName
    },
    {
        value: colMiscCompAmount,
        viewValue: colMiscCompAmount.headerName
    },
    {
        value: colNppSupervisoryAgreement,
        viewValue: colNppSupervisoryAgreement.headerName
    },
    {
        value: colNppSupervisoryAgreementDate,
        viewValue: colNppSupervisoryAgreementDate.headerName
    },
    {
        value: colNppAgreementOnFile,
        viewValue: colNppAgreementOnFile.headerName
    },
    {
        value: colRelocationAllowance,
        viewValue: colRelocationAllowance.headerName
    },
    {
        value: colRetentionBonus,
        viewValue: colRetentionBonus.headerName
    },
    {
        value: colRetentionBonusNotes,
        viewValue: colRetentionBonusNotes.headerName
    },
    {
        value: colRvuIncentiveInfo,
        viewValue: colRvuIncentiveInfo.headerName
    }
];




function  dateFormatter(params) {

    if (params.value == undefined) {
        return null;
    } else {
        let dateObject = moment(params.value);
        let friendlyDate = dateObject.format('ll');

        if (friendlyDate == 'Invalid date') {
            // console.log('invalid date: ', params.value);
            return params.value;
        } else {
            // console.log('valid date: ', friendlyDate);
            return friendlyDate;
        }
    }
}




function currencyFormatter(params) {

    let usdFormate = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
    });

    if (usdFormate.format(params.value) == '$0' ||
        (usdFormate.format(params.value) == '$NaN')) {
      return '$0.00';
    } else {
      return usdFormate.format(params.value);
    }

  }
